import {
  createContext, useContext,
} from 'react';

export const LayeredPortalContext = createContext<HTMLElement | null>(null);

export const useLayeredPortalTarget = () => useContext(LayeredPortalContext);
